import React, {useState} from 'react';
import style from './style.scss'

const ImageGroup = (props) => {
    const {field} = props;
    const img_size_style = ((field.disp_size_img > 0) ? {width: `${field.disp_size_img  }px`} : {});

    const [other, setOther] = useState(false);
    const [selected, setSelected] = useState({});

    const type = field.multiple ? 'checkbox' : 'radio';
    return (<div className={style.typeImgGroup}>

    <label className={style.formLabel}
        htmlFor={field.elementId}>
        {field.label}{field.required&&<span className={style.asterisk}> *</span>}
    </label>

        <div className={`${style.typeImgGroup} ${field.makeinline ? style.inline : ''}`}>

            {field.options.map((option, i) => {

                return (
                    <div
                        key={i}
                        className={`${style.image  } ${  (selected[i] || option.selected) ? style.selected : ''  } ${ style[field.disp_type]} ${ style[field.img_selection_type]}`} //
                        onClick={() => {
                            if (field.multiple) {
                                selected[i] = selected[i] ? !selected[i] : true;
                                setSelected(selected);
                            } else {
                                setSelected({[i]: true});
                            }
                        }
                        }
                    >

                        <img style={img_size_style}
                             src={(typeof option.thumb !== 'undefined' && option.thumb !== '' && option.thumb !== 'null') ? option.thumb : option.image}/>
                        <label className={style.tickBox} >{option.label}</label>
                    </div>
                );
            })}

            {field.other && <label className={style.checkBox}><input name={field.name}
                                                                     onChange={(ele) => {
                                                                         setOther(ele.target.checked)
                                                                     }} type={type}/>{wp.i18n.__('Other')}</label>}
            {field.other && other && <label><input type="text"/></label>}
        </div>
    </div>)
}

export default ImageGroup;
